import React from "react";

/** Gray placeholder block while data loads for the first time. Opacity-only animation (cheap). */
export function Skeleton({ className = "", style }) {
  return <div aria-hidden="true" style={style} className={`animate-pulse rounded bg-slate-200/80 dark:bg-slate-800 ${className}`} />;
}

const BARS = [28, 42, 36, 60, 82, 54, 70, 46, 64, 38, 56, 32];

/** Bar chart placeholder: same layout as the real chart, so nothing jumps. */
export function ChartSkeleton({ height = 220 }) {
  return (
    <div role="status" aria-label="Učitavanje" className="flex items-end gap-2 px-1" style={{ height }}>
      {BARS.map((h, i) => (
        <Skeleton key={i} className="flex-1 rounded-sm" style={{ height: `${h}%` }} />
      ))}
      <span className="sr-only">Učitavanje</span>
    </div>
  );
}

/** List row (name on the left, value on the right), e.g. revenue per employee. */
export function ListSkeleton({ rows = 5 }) {
  return (
    <div role="status" aria-label="Učitavanje" className="flex flex-col gap-3">
      {Array.from({ length: rows }, (_, i) => (
        <div key={i} className="flex items-center justify-between gap-6">
          <Skeleton className="h-3.5 w-28" />
          <Skeleton className="h-3.5 w-20" />
        </div>
      ))}
      <span className="sr-only">Učitavanje</span>
    </div>
  );
}
